import { Tooltip } from '@mui/material';
import React from 'react';

import { BLUR_STYLE } from '../../../providers/demo-blur';
import { Radio } from '../../../components/radio';
import Utils from '../../../utils/immersive_utils';
import './styles.scss';

interface ExchangeAccountListProps {
  accounts: any[];
  isPortfolioSidebarOpen: boolean;
  selectedAccountOption: any;
  handleOptionChange: (account: any) => void;
  isDisabledAccounts: boolean;
  calculatedAccountNames: Set<string>;
  icon: any;
  label: string;
  exchange: string;
  // Opt-in "blur names for demo" (Portfolio Management). Off by default.
  isBlurred?: boolean;
}

export const ExchangeAccountList: React.FC<ExchangeAccountListProps> = ({
  accounts,
  isPortfolioSidebarOpen,
  selectedAccountOption,
  handleOptionChange,
  isDisabledAccounts,
  calculatedAccountNames,
  icon,
  label,
  exchange,
  isBlurred = false,
}) => {
  if (!accounts.length) return null;

  return (
    <div className="portfolio-accounts-venue">
      <div className="portfolio-account-label">
        <img src={icon} alt={exchange} />
        <span>{label}</span>
      </div>
      <div className="portfolio-accounts-radios-data">
        {accounts.map((item, index) => {
          const isCalculated = calculatedAccountNames.has(item.name);
          return (
            <Tooltip
              key={`${item.name}-${index}`}
              title={!isBlurred && item.name.length >= 20 ? item.name : ''}
            >
              <div
                className={`portfolio-accounts-area-radio ${isPortfolioSidebarOpen && 'radio-hover'}`}
              >
                <Radio
                  label={
                    <span style={isBlurred ? BLUR_STYLE : undefined}>
                      {Utils.truncateLabel(item.name)}
                    </span>
                  }
                  checked={selectedAccountOption.name === item.name}
                  onChange={() => handleOptionChange(item)}
                  disabled={isDisabledAccounts}
                />
                {isPortfolioSidebarOpen && isCalculated && (
                  <div className="portfolio-accounts-circle-calculated" />
                )}
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};
